import { Component, Input } from "@angular/core";

@Component({
    selector: "upsell-wait",
    templateUrl: "upsell-wait.html",
    standalone: false
})

export class UpsellWaitComponent {
  @Input() iconWait: string = '';
  @Input() title: string = '';
  @Input() description: string = '';

  constructor() {}
}
